import React, { FC, useEffect, useState } from 'react';
import { classnames } from '@/utils/classnames';

export type TFlipCardState = 'front' | 'back';

interface IFlipCardProps {
  height?: number;
  width?: number;
  children?: React.ReactNode;
  className?: string;
  autoFlip?: boolean;
  timeInterval?: number;
  onFlipChange?: (__state: TFlipCardState) => void;
}

export const FlipCard: FC<IFlipCardProps> = ({
  height = 48,
  width = 48,
  children,
  className,
  autoFlip,
  timeInterval = 5000,
  onFlipChange,
}) => {
  const [flip, setFlip] = useState(false);

  const onFlipChangeHandler = (flip: boolean) => {
    if (onFlipChange) {
      setTimeout(() => {
        if (flip) {
          return onFlipChange('back');
        }
        return onFlipChange('front');
      }, 100);
    }
  };
  // Set up automatic flip every 5 seconds
  useEffect(() => {
    if (autoFlip) {
      const interval = setInterval(() => {
        setFlip((prev) => {
          onFlipChangeHandler(!prev);
          return !prev;
        }); // Toggle flip state
      }, timeInterval);
      // Clean up the interval on component unmount
      return () => clearInterval(interval);
    }
  }, [autoFlip]);

  return (
    <div className={classnames('py-1', className)}>
      <div className="group [perspective:1000px]" style={{ height, width }}>
        <div
          className={` relative h-full w-full rounded-xl  transition-all duration-500 [transform-style:preserve-3d] ${
            flip ? '[transform:rotateY(180deg)]' : ''
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
